<template>
  <div class="dashboard__table__header__bulk">
    <div class="dashboard__table__header__bulk__wrapper">
      <div style="flex: 1;">
        <div class="bulk__sliders-row">
          <div class="title">
              {{ $t('dashboard.bulk_setup.critical_value') }}:
          </div>
          <SensorSetup
            v-for="sensor in sensors"
            :key="sensor.label"
            :sensor="sensor"
            :inline="true"
            @onChange="setSensorValues"
          />
        </div>
          <div class="title">
              {{ $t('dashboard.bulk_setup.substrate_properties') }}:
          </div>
        <div class="bulk__batches" v-if="firstSelectedWithBatch">
          <div class="bulk__batches__property" :key="property.label"
               v-for="property in firstSelectedWithBatch.batch.type.properties">
                <span class="bulk__batches__property__label">
                  {{ property.label }}:
                </span>
            <span class="bulk__batches__property__drop dropdown"
                  v-if="property.type === 'choices'">
                  <select @change="updatedProperties" v-model="bulk.properties[property.key]" :disabled="!batchesIdentical">
                    <option :value="null"></option>
                    <option v-for="choice in property.values"
                            :value="choice"
                            :key="property.key + '_' + choice"
                            :selected="bulk.properties[property.key]">
                        {{ choice }}
                    </option>
                  </select>
                </span>
          </div>
          <div class="bulk__batches__warning" v-if="batchesIdentical === false">{{ $t('dashboard.bulk_setup.batch_type_error') }}</div>
          <div class="bulk__batches__warning" v-if="batchesIdentical === null">{{ $t('dashboard.bulk_setup.batch_missing_error') }}</div>
          <div class="bulk__batches__info" v-if="checkBulkProps && batchesIdentical">{{ $t('dashboard.bulk_setup.batch_all_error') }}</div>
        </div>
        <table>
          <tr>
            <td>
              <div class="title">
                  {{ $t('dashboard.bulk_setup.frame_selection') }}:
              </div>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                  <span class="bulk__payloads__formats__label">
                    {{ $t('detail.payload_format') }}
                  </span>
                    <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.userType">
                      <option :value="null"></option>
                      <option v-for="(format, type) in firstSelectedPayloadFormats.payload.payloadFormats"
                              :value="type"
                              :key="format.name"
                              :selected="null">
                          {{ format.name }}
                      </option>
                    </select>
                  </span>
                </div>

                <div class="bulk__payloads__warning" v-if="formatsIdentical === false">{{ $t('dashboard.bulk_setup.payload_error') }}</div>
                <div class="bulk__payloads__warning" v-if="this.frameMessage !== null">{{ this.frameMessage }}</div>
              </div>
            </td>

            <td>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.measurement_sets') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.userMessagesInInterval">
                      <option :value="null"></option>
                      <option v-for="value of accMeasurementsSets"
                              v-bind:key="value"
                              :value="value"
                              :selected="null">
                          {{ value }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>

            <td>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.measurement_interval') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.userOmittedMessages">
                      <option :value="null"></option>
                      <option v-for="(value, index) in measurementIntervals"
                              v-bind:key="index"
                              :value="index"
                              :selected="null">
                          {{ value }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>
            <td>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.downlik_period') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.downlinkPeriod">
                      <option :value="null"></option>
                      <option v-for="period of downlinkPeriods"
                              v-bind:key="period.value"
                              :value="period.value"
                              :selected="null">
                          {{ period.label }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.downlink_retries') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.downlinkRetries">
                      <option :value="null"></option>
                      <option v-for="(value, index) of downlinkRetriesArray"
                              v-bind:key="value"
                              :value="value"
                              :selected="null">
                          {{ index }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>
            <td>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.transmitting_power') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.transmittingPower">
                      <option :value="null"></option>
                      <option v-for="(value, index) of transmittingPowerArray"
                              v-bind:key="value"
                              :value="value"
                              :selected="null">
                          {{ index }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>

            <td>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                  <span class="bulk__payloads__formats__label">
                    {{ $t('detail.message_interval') }}
                  </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <span>{{messageInterval}}</span>
                    <input id="message_interval" style="visibility: hidden" type="text" disabled :value="messageInterval">
                  </span>
                </div>
              </div>
            </td>

            <td>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                  <span class="bulk__payloads__formats__label">
                    {{ $t('detail.device_lifespan') }}
                  </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    {{deviceLifespan}}
                    <input id="device_lifespan" style="visibility: hidden" type="text" disabled :value="deviceLifespan">
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </table>

          <div class="title">
              {{ $t('dashboard.nav.remark') }}:
          </div>
          <div class="bulk__selects-row">
          <BaseInput v-model="bulk.remark" style="margin-right: 1.5rem;" />
        </div>
          <BaseButton
                  @click.native="applyChanges(bulk)"
                  class="bulk__selects-row-item--mobile"
                  v-responsive.xs>
              {{ $t('buttons.apply') }}
          </BaseButton>
      </div>
      <div class="bulk__button-wrapper" v-responsive.sm.md.lg.xl>
        <BaseButton @click.native="applyChanges(bulk)">{{ $t('buttons.apply') }}</BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dynamicTiming, dynamicSensing } from '@/config/tentacles';
import SensorSetup from '@/components/SensorSetup.vue';

export default {
  name: 'DashboardBulkSetup',
  components: {
    SensorSetup,
  },
  props: {
    sensors: {
      type: Array,
      default: value => [],
    },
    unitsID: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      SOIL_3XS: 1,
      showTimSen: false,
      checkBulkProps: true,
      frameMessage: null,
      bulk: {
        dynamicTiming: null,
        dynamicSensing: null,
        remark: null,
        userType: null,
        userMessagesInInterval: null,
        userOmittedMessages: null,
        downlinkPeriod: null,
        downlinkRetries: null,
        transmittingPower: null,
        sensors: [],
        properties: {},
      },
      downlinkRetriesArray: {'0':'0', '1':'1', '2':'2', '3':'3'},
      transmittingPowerArray: {'65%':'0', '80%':'1', '100%':'2', '125%':'3'},
    };
  },
  mounted() {
    for (let i = 0; i < this.sensors.length; i += 1) {
      this.bulk.sensors.push({ sensorId: this.sensors[i].sensorId, minCrit: null, maxCrit: null });
    }
  },
  computed: {
    ...mapGetters('tentacle', ['type']),
    dynamicTiming() {
      for (let i = 0; i < dynamicTiming.length; i += 1) {
        dynamicTiming[i].name = this.$t(`timing.${dynamicTiming[i].label}`);
      }
      return dynamicTiming;
    },
    dynamicSensing() {
      for (let i = 0; i < dynamicSensing.length; i += 1) {
        dynamicSensing[i].name = this.$t(`sensing.${dynamicSensing[i].label}`);
      }
      return dynamicSensing;
    },
    firstSelectedWithBatch() {
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.batch === null ){
          continue;
        }

        for (var key in tentacle.properties) {
          this.bulk.properties[key] = null;
        }

        return tentacle;
      }

      return false;
    },
    firstSelectedPayloadFormats() {
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.payload === null ){
          continue;
        }

        return tentacle;
      }

      return false;
    },
    batchesIdentical(){
      let batchType = null;
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.batch === null ){
          return null;
        }

        if (batchType === null){
          batchType = tentacle.batch.type.id;
        } else {
          if (batchType !== tentacle.batch.type.id) {
            return false;
          }
        }
      }

      return true;
    },
    formatsIdentical(){
      let formatType = null;
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.payload === null ){
          return null;
        }

        if (formatType === null){
          formatType = tentacle.payload.ackType;
        } else {
          if (formatType !== tentacle.payload.ackType) {
            return false;
          }
        }
      }

      return true;
    },
    accMeasurementsSets: function() {
      let range = [];
      if (this.bulk.userType != null) {
        range = this.firstSelectedPayloadFormats.payload.payloadFormats[this.bulk.userType].options;
      }
      return range;
    },
    measurementIntervals: function () {
      if (parseInt(this.bulk.userType) === 6) {
        this.bulk.userOmittedMessages = 15;
        return {15: 240};
      }

      const range = {};
      for (let i = 0; i <= 15; i += 1) {
        range[i] = (i + 1) * 15;
      }
      return range;
    },
    messageInterval: function () {
      let interval = ((parseInt(this.bulk.userOmittedMessages) + 1) * 15) * parseInt(this.bulk.userMessagesInInterval);
      if (isNaN(interval)) {
        return "-";
      }
      return interval;
    },
    downlinkPeriods: function () {
      if (parseInt(this.bulk.userOmittedMessages) === 0 && parseInt(this.bulk.userMessagesInInterval) === 1) {
        if (parseFloat(this.bulk.downlinkPeriod) === 0.25){
          this.bulk.downlinkPeriod = 0.50;
        }
        return [
          {
            label: this.$t('detail.once_per_two'),
            value: 0.50,
          },
          {
            label: this.$t('detail.once_per_day'),
            value: 1,
          },
          {
            label: this.$t('detail.twice_per_day'),
            value: 2,
          },
        ]
      } else if (parseInt(this.bulk.userType) === 6 && parseInt(this.bulk.userMessagesInInterval) === 6) {
        this.bulk.downlinkPeriod = 1;
        return [{ label: this.$t('detail.once_per_day'), value: 1 }];
      } else if (parseInt(this.bulk.userType) === 6 && parseInt(this.bulk.userMessagesInInterval) === 12) {
        this.bulk.downlinkPeriod = 0.5;
        return [{ label: this.$t('detail.once_per_two'), value: 0.5 }];
      } else {
        return [
          {
            label: this.$t('detail.once_per_four'),
            value: 0.25,
          },
          {
            label: this.$t('detail.once_per_two'),
            value: 0.50,
          },
          {
            label: this.$t('detail.once_per_day'),
            value: 1,
          },
          {
            label: this.$t('detail.twice_per_day'),
            value: 2,
          },
        ]
      }
    },
    deviceLifespan: function () {
      const maxMeasurments = {
        1: 3,
        2: 5,
        3: 4,
        4: 10,
        5: 4,
        6: 15,
      };

      var messageRatio = parseInt(this.bulk.userMessagesInInterval) / maxMeasurments[this.bulk.userType];  // maxMeasurementsInFrame is variable defining maximum measurement sets in current frame. It changes when different frame is selected.
      let messageConsumption = 0.23424;
      if (messageRatio < 0.32) {
        messageConsumption = 0.169824;
      } else if (messageRatio < 0.65) {
        messageConsumption = 0.20496;
      }
      let lifespan = (5040 / ((1.380821918 + (1440 / parseInt(this.messageInterval)) * messageConsumption + 0.20528 * parseFloat(this.bulk.downlinkPeriod)) * 365) ).toFixed(1);

      if (isNaN(lifespan)) {
        return "-";
      }
      return lifespan;
    },
  },
  methods: {
    updatedProperties() {
      this.checkBulkProps = this.checkProps(this.bulk.properties);
    },
    checkProps(props) {
      for (var key in props) {
        if (props[key] === null || props[key] === ''){
          return true;
        }
      }
      return false;
    },
    setBulkDynamicTiming(option) {
      this.bulk.dynamicTiming = option;
    },
    setBulkDynamicSensing(option) {
      this.bulk.dynamicSensing = option;
    },
    setSensorValues(newValues) {
      this.bulk.sensors = this.bulk.sensors.map((sensor) => {
        if (sensor.sensorId === newValues.sensor_id) {
          sensor.minCrit = newValues.values[0];
          sensor.maxCrit = newValues.values[1];
        }
        return sensor;
      });
    },
    applyChanges(bulkOptions) {
      if (bulkOptions.userType) {
        if (
          !bulkOptions.userMessagesInInterval
          || !bulkOptions.userOmittedMessages
          || !bulkOptions.downlinkPeriod
        ) {
          this.frameMessage = this.$t('dashboard.bulk_setup.batch_all_error');
          return;
        }
      }
      else {
        this.frameMessage = null;
      }
      // move to function
      const newTentacles = [];
      // no for int i cycle
      for (let i = 0; i < this.unitsID.length; i += 1) {
        const tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);
        newTentacles.push({
          id: this.unitsID[i],
          remark: bulkOptions.remark,
          userPayloadFormatType: bulkOptions.userType,
          userMessagesInInterval: bulkOptions.userMessagesInInterval,
          userOmittedMessages: bulkOptions.userOmittedMessages,
          downlinkPeriod: bulkOptions.downlinkPeriod,
          downlinkRetries: bulkOptions.downlinkRetries,
          transmittingPower: bulkOptions.transmittingPower,
          properties: this.checkProps(bulkOptions.properties) ? null : JSON.stringify(bulkOptions.properties),
          measurementInterval: bulkOptions.dynamicTiming ? bulkOptions.dynamicTiming.value : null,
          dynamicSensing: bulkOptions.dynamicSensing ? bulkOptions.dynamicSensing.value : null,
          sensors: bulkOptions.sensors.reduce((bulkSensors, bulkSensor) => {
            const sensor = tentacle.sensors.filter(tentacleSensor => tentacleSensor.sensorId === bulkSensor.sensorId);
            if (sensor.length) {
              bulkSensors.push({
                id: sensor[0].id,
                ...bulkSensor,
              });
            }
            return bulkSensors;
          }, []),
        });
      }
      this.$store.dispatch('tentacle/updateUnit', newTentacles).then((response) => {
        if (response.status === 200) {
          this.flash('Tentacles updated', 'success');
        }
      });

      let customer = this.$store.getters['customer/customer'];
      let type = this.$store.getters['tentacle/type'];
      let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[0]);
      let params = {customer: customer, type: type};
      this.$store.dispatch('tentacle/setType', params);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
    padding-left: 1.5rem;
    color: #a5a5a6;
    font-size: 1.3rem;
    font-weight: 600;
}

.dashboard__table__header__bulk {
  background-color: white;
  box-shadow: 0 0 1rem rgba(100, 100, 100, 0.1) inset;
  transition: all 0.4s;

  &__wrapper {
    padding: 2.5rem 1.5rem;
    display: flex;
  }

  .bulk {
    display: flex;
    align-items: stretch;
    &__sliders-row {
      margin-bottom: 3.5rem;
    }
    &__selects-row {
      padding: 0 3rem;
      display: flex;
      align-items: center;

        &-item--mobile {
            @media only screen and (max-width: 991px) {
                width:100%;
                margin-top: 2em;
            }
        }

        @media only screen and (max-width: 991px) {
            flex-direction: column;
            align-items: start;
        }
      .select {
        margin-right: 2rem;
        width: 24rem;
      }
    }

    &__button-wrapper {
      margin-left: auto;
      justify-self: end;
      padding-left: 2rem;
      display: flex;
      align-items: flex-end;

      .btn {
          width: max-content;
      }
    }

    &__batches {
      display: flex;
      align-items: center;
      margin-bottom: 2.5rem;
      padding: 1.5rem 3rem;

        &__property {
            font-size: small;
            margin-right: 3rem;

            &__drop > select {
                border: 1px solid #eee;
                color: #6f6f6f;
                background-color: #f5f5f5;
                border-radius: 3px;
                line-height: 4rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;

                :disabled {
                    color: red;
                }
            }

            &__drop > select:disabled {
                border: 1px solid #eee;
                background-color: #f5f5f5;
                border-radius: 3px;
                line-height: 4rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;
                color: red;
            }
        }

        &__property > span {
            margin-right: 1rem;
        }


      &__warning {
        padding: 2px 15px;
        display: inline-block;
        margin-right: 2rem;
        color: red;
        font-size: medium;
      }

      &__info {
        padding: 2px 15px;
        display: inline-block;
        margin-right: 2rem;
        color: #a5a5a6;
        font-size: medium;
      }
    }

    &__payloads {
      display: flex;
      align-items: center;
      margin-bottom: 2.5rem;
      padding: 1.5rem 3rem;

        &__formats {
            font-size: small;
            margin-right: 3rem;

            &__drop > select {
                border: 1px solid #eee;
                color: #6f6f6f;
                background-color: #f5f5f5;
                border-radius: 3px;
                line-height: 4rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;

                :disabled {
                    color: red;
                }
            }

            &__drop > select:disabled {
                border: 1px solid #eee;
                background-color: #f5f5f5;
                border-radius: 3px;
                line-height: 4rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;
                color: red;
            }
        }

        &__formats > span {
            margin-right: 1rem;
        }

      &__warning {
        padding: 2px 15px;
        display: inline-block;
        margin-right: 2rem;
        color: red;
        font-size: medium;
      }
    }
  }
}
.bulk__payloads__formats__label {
  display: inline-block;
  margin-bottom: 5px;
}
</style>
